import {
  Button,
  Flex,
  LoadingOverlay,
  Textarea,
  TextInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { notifications } from "@mantine/notifications";
import { Box } from "lucide-react";
import { getAboutUs, postAboutUs } from "modules/api";
import { useEffect, useState } from "react";

const AboutUs = () => {
  const [isLoading, setIsLoading] = useState(false);
  const form = useForm({
    mode: "uncontrolled",
    initialValues: {
      addressEn: "",
      addressRu: "",
      addressUz: "",
      companyName: "",
      descriptionEn: "",
      descriptionUz: "",
      descriptionRu: "",
      email: "",
      firstPhoneNumber: "",
      secondPhoneNumber: "",
      shortNumber: "",
      telegramBot: "",
      link2Facebook: "",
      link2Instagram: "",
      link2Telegram: "",
      link2YouTube: "",
    },

    validate: {
      // email: (value) => (/^\S+@\S+$/.test(value) ? null : "Invalid email"),
    },
  });

  useEffect(() => {
    (async () => {
      try {
        const res = await getAboutUs();
        const data = res?.data?.data;
        form.setFieldValue("addressEn", data.address.en);
        form.setFieldValue("addressRu", data.address.ru);
        form.setFieldValue("addressUz", data.address.uz);
        form.setFieldValue("companyName", data.companyName);
        form.setFieldValue("descriptionEn", data.description.en);
        form.setFieldValue("descriptionRu", data.description.ru);
        form.setFieldValue("descriptionUz", data.description.uz);
        form.setFieldValue("email", data.email);
        form.setFieldValue("firstPhoneNumber", data.firstPhoneNumber);
        form.setFieldValue("link2Facebook", data.link2Facebook);
        form.setFieldValue("link2Instagram", data.link2Instagram);
        form.setFieldValue("link2Telegram", data.link2Telegram);
        form.setFieldValue("link2YouTube", data.link2YouTube);
        form.setFieldValue("secondPhoneNumber", data.secondPhoneNumber);
        form.setFieldValue("shortNumber", data.shortNumber);
        form.setFieldValue("telegramBot", data.telegramBot);
        console.log("🚀 ~ res:", res?.data?.data);
      } catch (error) {}
    })();
  }, []);

  const onSubmit = async (values: any) => {
    console.log("🚀 ~ onSubmit ~ values:", values);
    try {
      setIsLoading(true);
      const res = await postAboutUs(values, 1);
      notifications.show({
        title: "About-us information successfully updated",
        message: null,
        color: "green",
      });
    } catch (error: any) {
      notifications.show({
        title: "Update failed",
        message: null,
        color: "red",
      });
      console.log("🚀 ~ onSubmit ~ error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <LoadingOverlay
        visible={isLoading}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 2 }}
      />
      <form onSubmit={form.onSubmit((values: any) => onSubmit(values))}>
        <Flex
          gap="md"
          justify="flex-start"
          align="flex-start"
          wrap="wrap"
          direction={"column"}
        >
          <Flex gap={"md"} className="w-full">
            <TextInput
              className="w-full"
              label="Address en"
              placeholder="Please enter address en"
              {...form.getInputProps("addressEn")}
            />
            <TextInput
              className="w-full"
              label="Address ru"
              placeholder="Please enter address ru"
              {...form.getInputProps("addressRu")}
            />
            <TextInput
              className="w-full"
              label="Address uz"
              placeholder="Please enter address uz"
              {...form.getInputProps("addressUz")}
            />
          </Flex>
          <Flex gap={"md"} className="w-full">
            <TextInput
              className="w-full"
              label="Email"
              placeholder="Please enter email"
              {...form.getInputProps("email")}
            />
            <TextInput
              className="w-full"
              label="First phone number"
              placeholder="Please enter first phone number"
              {...form.getInputProps("firstPhoneNumber")}
            />
            <TextInput
              className="w-full"
              label="Second phone number"
              placeholder="Please enter second phone number"
              {...form.getInputProps("secondPhoneNumber")}
            />
          </Flex>
          <Flex gap={"md"} className="w-full">
            <TextInput
              className="w-full"
              label="Short number"
              placeholder="Please enter short number"
              {...form.getInputProps("shortNumber")}
            />
            <TextInput
              className="w-full"
              label="Telegram bot"
              placeholder="Please enter telegram bot"
              {...form.getInputProps("telegramBot")}
            />
            <TextInput
              className="w-full"
              label="Link to facebook"
              placeholder="Please enter link to facebook"
              {...form.getInputProps("link2Facebook")}
            />
          </Flex>
          <Flex gap={"md"} className="w-full">
            <TextInput
              className="w-full"
              label="Link to Instagram"
              placeholder="Please enter link to Instagram"
              {...form.getInputProps("link2Instagram")}
            />
            <TextInput
              className="w-full"
              label="Link to Telegram"
              placeholder="Please enter link to Telegram"
              {...form.getInputProps("link2Telegram")}
            />
            <TextInput
              className="w-full"
              label="Link to YouTube"
              placeholder="Please enter link to YouTube"
              {...form.getInputProps("link2YouTube")}
            />
          </Flex>
          <Flex gap={"md"} className="w-full">
            <TextInput
              className="w-full"
              label="Company name"
              placeholder="Please enter company name"
              {...form.getInputProps("companyName")}
            />
          </Flex>
          <Flex gap={"md"} className="w-full">
            <Textarea
              className="w-full"
              label="Description en"
              placeholder="Please enter description en"
              {...form.getInputProps("descriptionEn")}
            />
          </Flex>
          <Flex gap={"md"} className="w-full">
            <Textarea
              className="w-full"
              label="Description ru"
              placeholder="Please enter description ru"
              {...form.getInputProps("descriptionRu")}
            />
          </Flex>
          <Flex gap={"md"} className="w-full">
            <Textarea
              className="w-full"
              label="Description uz"
              placeholder="Please enter description uz"
              {...form.getInputProps("descriptionUz")}
            />
          </Flex>
        </Flex>
        <Flex justify={"end"} mt={20}>
          <Button className="mx-2" type="submit">
            Updated
          </Button>
        </Flex>
      </form>
    </div>
  );
};

export default AboutUs;
